export const HEADER_TEXT = $localize`Access Point Summary`;
